import React, { ReactNode, useState } from 'react';
import { Typography } from '../Typography/Typography';
import classNames from 'classnames/bind';
import styles from './Tooltip.module.scss';

const cx = classNames.bind(styles);

export interface ITooltipProps {
  text: string;
  children: ReactNode;
  position?: 'top' | 'bottom';
  hasArrow?: boolean;
  buttonColor?: 'kale' | 'tomato';
  tooltipColor?: 'kale' | 'tomato';
}

const Tooltip = ({
  text,
  children,
  position = 'top',
  hasArrow = true,
  buttonColor = 'kale',
  tooltipColor = 'kale',
}: ITooltipProps) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const handleMouseEnter = () => setShowTooltip(true);
  const handleMouseLeave = () => setShowTooltip(false);
  const handleClick = () => setShowTooltip((showTooltip: boolean) => !showTooltip);

  return (
    <div className={styles['tooltip']}>
      <div
        className={cx('tooltip-target', {
          [`tooltip-target-${buttonColor}`]: buttonColor,
        })}
        role="button"
        aria-label="tooltip-target"
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
      <div
        className={cx('tooltip-text', {
          ['is-open']: showTooltip,
          [`tooltip-text-${position}`]: position,
          ['has-arrow']: hasArrow,
          [`tooltip-text-background-${tooltipColor}`]: tooltipColor,
        })}
        role="tooltip"
        aria-label="tooltip-text"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Typography color="secondary" size="M">
          {text}
        </Typography>
      </div>
    </div>
  );
};

export default Tooltip;
